import React, { useState, useEffect } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import Header from '@/components/Header';
import Hero from '@/components/Hero';
import Services from '@/components/Services';
import WhyMe from '@/components/WhyMe';
import Process from '@/components/Process';
import Portfolio from '@/components/Portfolio';
import Contact from '@/components/Contact';
import Footer from '@/components/Footer';
import MessageReceived from '@/components/MessageReceived';
import AlpineRetreat from '@/components/examples/AlpineRetreat';
import LakeviewManor from '@/components/examples/LakeviewManor';
import UrbanSuites from '@/components/examples/UrbanSuites';
import ChateauBelleville from '@/components/examples/ChateauBelleville';
import ZenRetreat from '@/components/examples/ZenRetreat';
import { translations } from '@/data/mock';

const HomePage = ({ currentLang, setLanguage, t }) => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80; // Account for fixed header
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <>
      <Header
        t={t}
        currentLang={currentLang}
        setLanguage={setLanguage}
        scrollToSection={scrollToSection}
      />
      <Hero t={t} scrollToSection={scrollToSection} />
      <Services t={t} />
      <WhyMe t={t} />
      <Process t={t} />
      <Portfolio t={t} />
      <Contact t={t} currentLang={currentLang} />
      <Footer t={t} />
    </>
  );
};

function App() {
  const [currentLang, setCurrentLang] = useState('en');

  // Browser language detection
  useEffect(() => {
    // Check localStorage first
    const savedLang = localStorage.getItem('biteSiteLang');
    if (savedLang) {
      setCurrentLang(savedLang);
    } else {
      const browserLang = navigator.language || navigator.userLanguage;
      if (browserLang.startsWith('fr')) {
        setCurrentLang('fr');
      }
    }
  }, []);

  // Save language to localStorage when changed
  const handleLanguageChange = (lang) => {
    setCurrentLang(lang);
    localStorage.setItem('biteSiteLang', lang);
  };

  const t = translations[currentLang];

  return (
    <div className="App bg-slate-950">
      <Toaster position="top-right" />
      <BrowserRouter>
        <Routes>
          <Route 
            path="/" 
            element={<HomePage currentLang={currentLang} setLanguage={handleLanguageChange} t={t} />} 
          />
          <Route 
            path="/message-received" 
            element={<MessageReceived />} 
          />
          <Route 
            path="/example/alpine-retreat" 
            element={<AlpineRetreat />} 
          />
          <Route 
            path="/example/lakeview-manor" 
            element={<LakeviewManor />} 
          />
          <Route 
            path="/example/urban-suites" 
            element={<UrbanSuites />} 
          />
          <Route 
            path="/example/chateau-belleville" 
            element={<ChateauBelleville />} 
          />
          <Route 
            path="/example/zen-retreat" 
            element={<ZenRetreat />} 
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
